import { Box, Card } from '@zillow/constellation-10';
import { LoadingTag, LoadingText } from '@zg-rentals/loading-components';

type PaymentCardSkeletonProps = {
  isMobile?: boolean;
};

export const PaymentCardSkeleton = ({ isMobile = false }: PaymentCardSkeletonProps) => {
  if (isMobile) {
    // Mobile version - vertical stacking
    return (
      <Card
        elevated={false}
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          padding: 'loose',
          gap: 'tighter',
        }}
        data-testid="PaymentCardSkeleton-Mobile"
      >
        <Box
          css={{
            display: 'flex',
            flexDirection: 'column',
            alignSelf: 'stretch',
            gap: 'tighter',
          }}
        >
          <Box
            css={{
              display: 'flex',
              flexDirection: 'column',
              gap: 'tighter',
              alignItems: 'flex-start',
            }}
          >
            <Box
              css={{
                display: 'flex',
                flexDirection: 'column',
                gap: 'tighter',
                width: '100%',
              }}
            >
              <LoadingText isLoading loadingWidth="40%">
                Loading
              </LoadingText>
              <LoadingText isLoading loadingWidth="45%">
                Loading
              </LoadingText>
            </Box>
            <LoadingTag isLoading loadingWidth="65%">
              Tag
            </LoadingTag>
          </Box>
          <LoadingText isLoading loadingWidth="100%">
            Loading
          </LoadingText>
        </Box>
        <LoadingText isLoading loadingWidth="50%">
          Loading
        </LoadingText>
      </Card>
    );
  }

  // Desktop version - horizontal layout
  return (
    <Card
      elevated={false}
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: 'loose',
        gap: 'loose',
      }}
      data-testid="PaymentCardSkeleton-Desktop"
    >
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignSelf: 'stretch',
          gap: 'loose',
        }}
      >
        <Box
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'micro.default',
          }}
        >
          <Box
            css={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <LoadingText isLoading loadingWidth="30%">
              Loading
            </LoadingText>
            <LoadingTag isLoading loadingWidth="40%">
              Tag
            </LoadingTag>
          </Box>
          <LoadingText isLoading loadingWidth="40%">
            Loading
          </LoadingText>
        </Box>
        <LoadingText isLoading loadingWidth="75%">
          Loading
        </LoadingText>
      </Box>
      <LoadingText isLoading loadingWidth="50%">
        Loading
      </LoadingText>
    </Card>
  );
};
